import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
import type { LinkType } from './types'

@safeCustomElement('mdc-link')
export class MdcLink extends LitElement {
  @property({ type: String }) type: LinkType = 'primary'
  @property({ type: String }) href = ''
  @property({ type: String }) text = ''
  @property({ type: Boolean }) disabled = false

  static styles = css`
		:host {
			display: inline;
			font-family: var(--typography-font-family-sans);
		}

		.mdc-link {
			box-sizing: border-box;
			text-decoration: none;
			font-size: var(--text-087-and-half);
			font-weight: 450;
			line-height: 1.3;
			transition: color 0.2s ease-in-out;
			text-decoration-line: none;
		}

		.mdc-link:focus-visible {
			box-shadow: 0 0 0 2px var(--color-functional-blue-300);
			outline: none;
		}

		.mdc-link:disabled,
		.mdc-link[aria-disabled='true'] {
			color: var(--color-functional-gray-300);
		}

		.mdc-link--type-primary {
			color: var(--color-functional-gray-black);
		}

		.mdc-link--type-primary:hover,
		.mdc-link--type-primary:focus-visible {
			color: var(--color-functional-gray-400);
		}

		.mdc-link--type-secondary {
			color: var(--color-functional-gray-400);
		}

		.mdc-link--type-secondary:hover,
		.mdc-link--type-secondary:focus-visible {
			color: var(--color-functional-gray-900);
		}

		.mdc-link--type-inverse-primary {
			color: var(--color-functional-gray-white);
		}

		.mdc-link--type-inverse-primary:hover,
		.mdc-link--type-inverse-primary:focus-visible {
			color: var(--color-functional-gray-200);
		}

		.mdc-link--type-inverse-secondary {
			color: var(--color-functional-gray-200);
		}

		.mdc-link--type-inverse-secondary:hover,
		.mdc-link--type-inverse-secondary:focus-visible {
			color: var(--color-functional-gray-white);
		}

	`

  render() {
    const className = `mdc-link mdc-link--type-${this.type}`

    if (!this.disabled) {
      return html`<a class=${className} href=${this.href}>${this.text}</a>`
    }

    return html`<span class=${className} aria-disabled="true">${this.text}</span>`
  }
}
